const VARIANT = (process.env.REACT_APP_VARIANT || '').toLowerCase();
const suffix = VARIANT === 'urclyrd' ? '-urclyrd' : '';

export function getLogoPath(type) {
  switch (type) {
    case 'alt':
      return `/logo-alt${suffix}.png`;
    case 'green-gray':
      return `/logo-green-gray${suffix}.png`;
    case 'default':
    default:
      return `/logo${suffix}.png`;
  }
}